import axios from "axios"
import { adapterCatalogo } from "./Catalogo.adapter"
import { CatalogoReadingDtoProps } from "./DTOs/CatalogoReadingDto"

export interface getCatalogoParams {
  nombre: string
}

export async function getCatalogoByFilters(
  queryParams?: getCatalogoParams
): Promise<CatalogoReadingDtoProps[]> {
  const { data }: { data: CatalogoReadingDtoProps[] } = await axios.get(
    "/Catalogo/by-filters",
    { params: queryParams }
  )
  return data.map((catalogo: CatalogoReadingDtoProps) =>
    adapterCatalogo(catalogo)
  )
}
